export enum CruiseExtra {
    Buffet,

    Snacks,

    Alcohol,

    FishingEquipment
}

export enum CruiseOrderState {
    New,

    Processing,

    Rejected,

    Approved,
    
    Canceled
}

export enum VisitingPointDuration
{
    Min10,
    
    Min30,
    
    H1,
    
    H2,
    
    H3,
    
    H4,
    
    H5
}

export enum CruiseDuration {
    JustRide,

    H1,

    H2,

    H3,

    H4,

    H5
}

export enum CruiseTimeOfDay {
    Morning,
    
    Day,
    
    Evening
}

export enum CruiseGroupSize {
    Standard,
    
    Big,
    
    Waterbus,
    
    Rib,
    
    Classic,
        
    Sail,

    Fishing,

    Hovercraft,

    Electric
}

export enum LoginResultStatus {
    Success,

    NotFound,

    Deleted,

    Locked,

    /**
     * Token security stamp does not correspond to user security stamp
     */
    TokenInvalidSecurityStamp,

    /**
     * Token already used
     */
    TokenUsed,

    /**
     * Token invalid or expired
     */
    TokenInvalidOrExpired
}

export enum InvitationType {
    Invitation,

    ResetPassword,

    ForgotPassword
}

export enum NotificationType {
    Sms,

    Application,

    Push,

    Email
}

export enum AuthType {
    Email,

    Phone
}

export enum AuditTimestamp {
    CreatedAt,

    ModifiedAt
}

export enum SavePasswordResultStatus {
    Success,

    WeakPassword,

    WrongCurrent
}

export enum OrganizationContractLevel {
    Operator = 0,

    Company = 1,

    SubCompany = 2
}

export enum OrganizationContractType {
    Customer = 0,

    Subcontractor = 1
}